import animation from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { scrollbar } from '@helpers/scrollbar';
import { ButtonStyles } from '@stories/Elements/Forms/Buttons/Button.styles';
import { Grid } from '@stories/Settings/Grids/Grid.styles';
import styled, { css } from 'styled-components';

const HEIGHT = 64;

const Container = styled.nav<{ isActive: boolean }>`
  background-color: ${brand.black}d7;
  height: ${HEIGHT}px;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 100;
  position: fixed;
  transition: transform 250ms ${animation.easeInOutCubic};

  ${({ isActive }) =>
    isActive
      ? css`
          transform: translateY(0%);
        `
      : css`
          transform: translateY(-100%);
        `}
`;

const _grid = styled(Grid.Default)`
  height: 100%;
  align-items: center;

  ${ButtonStyles.ButtonElement} {
    grid-column-start: -1;
    display: none;

    @media ${from(Device.DesktopSmall)} {
      display: inline-block;
    }
  }
`;

const Items = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  flex-wrap: nowrap;
  grid-column: span 12;
  height: 100%;
  overflow-x: auto;
  ${scrollbar(brand.black, brand.black, brand.grey[60])}

  @media ${from(Device.DesktopSmall)} {
    grid-column: span 11;
  }
`;

const Item = styled.div<{ isActive?: boolean }>`
  position: relative;
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:after {
    content: '';
    height: 4px;
    width: 40px;
    background-color: ${brand.red.base};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    transition: opacity 500ms ${animation.easeInOutCubic};
  }

  ${({ isActive }) =>
    isActive
      ? css`
          &:after {
            opacity: 1;
          }
        `
      : css`
          &:after {
            opacity: 0;
          }
        `}

  a {
    font-size: 18px;
    ${fonts.helvetica['97-black-condensed']};
    letter-spacing: ${fonts.ls(25)};
    text-transform: uppercase;
    color: ${brand.white};
  }
`;

const MobileOnlyClickToBuyWrapper = styled.div<{ show: boolean; isScrollToTopButtonVisible: boolean }>`
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
  // This odd padding is done as such in order to line-up Cluck2Buy with the "ScrollToTop" button
  padding: 10px 16px 4px;
  transition: transform 250ms ${animation.easeInOutCubic};
  background-color: ${brand.black}d7;

  display: flex;
  justify-content: flex-start;

  ${ButtonStyles.ButtonElement} {
    transition: width 0.35s ${animation.easeInOutCubic};
  }

  ${({ isScrollToTopButtonVisible }) =>
    isScrollToTopButtonVisible
      ? css`
          ${ButtonStyles.ButtonElement} {
            // Full width minus "ScrollToTop" width
            width: calc(100% - 50px);
          }
        `
      : css`
          ${ButtonStyles.ButtonElement} {
            width: 100%;
          }
        `}

  ${({ show }) =>
    show
      ? css`
          transform: translateY(0%);
        `
      : css`
          transform: translateY(100%);
        `}

  @media ${from(Device.TabletLarge)} {
    justify-content: center;

    ${ButtonStyles.ButtonElement} {
      width: auto;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;

export const ProductNavigationStyles = {
  Container,
  Items,
  Item,
  Grid: _grid,
  MobileOnlyClickToBuyWrapper,
};
